import { SET_ORDER } from "../../types";

const setOrder = (order) => (dispatch) => {
  dispatch({ type: SET_ORDER, order });
};

export { setOrder };
